module.exports = __webpack_public_path__ + "static/bg01-1cb0388a8b1f3d423ea453519c6a89a5.png";